"use client";

import { ButtonIcon } from "@/components";
import { useLayout, useTheme } from "@/providers";
import { useEffect, useState } from "react";

const ModeSwitcher = () => {
  const { t } = useLayout();
  const { theme, changeTheme } = useTheme();

  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  return (
    <ButtonIcon
      aria-label={t("alternateThemeMode")}
      action={() => changeTheme(theme === "light" ? "dark" : "light")}
      className="btn-rounded"
      iconLeft={{
        name: theme === "light" ? "bx bx-moon" : "bx bx-sun",
        size: "4x"
      }}
    />
  );
};

export default ModeSwitcher;
